import React, { Component } from 'react';

import InlineEditName from './PersonalInfo/Name';
import InlineEditBirthdate from './PersonalInfo/Birthdate';
import InlineEditEmail from './PersonalInfo/Email';
import InlineEditPhone from './PersonalInfo/Phone';
import InlineEditAccountPassword from './PersonalInfo/AccountPassword'

class PersonalInfo extends Component {
  render() {
    return (
      <div>
        <h3>Personal Info</h3>
        <div className="static-field-container">
          <InlineEditName {...this.props.personalInfo} {...this.props} />
          <InlineEditBirthdate {...this.props.personalInfo} {...this.props} />
          <InlineEditEmail {...this.props.personalInfo} {...this.props} />
          <InlineEditPhone {...this.props.personalInfo} {...this.props} />
          <InlineEditAccountPassword {...this.props.personalInfo} {...this.props} />
          {/* PBI 450387 VOA: Remove the 'SIN' optional field from the application form */}
        </div>
      </div>);
  }
}

export default PersonalInfo;


// WEBPACK FOOTER //
// ./src/containers/Review/InlineEdit/PersonalInfo.js